<app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
<div *ngIf="!loading">
    <!-- <br> -->
    <div class="row" *ngIf="listaVacia">
        <div class="form-group col-12">
            <div [class]="'alert alert-'+ class +' animated fadeInRight'" role="alert">
                <b> {{ texto }} </b>
            </div>
        </div>
    </div>
</div>